import { render, staticRenderFns } from "./TrashSVG.vue?vue&type=template&id=ab409e74&"
import script from "./TrashSVG.vue?vue&type=script&lang=js&"
export * from "./TrashSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports